export const spreadsheetFileTypeEnum = {
  CSV: 'CSV',
  XLSX: 'XLSX',
} as const

export type SpreadsheetFileTypeEnum = (typeof spreadsheetFileTypeEnum)[keyof typeof spreadsheetFileTypeEnum]

export type SpreadsheetFileType = SpreadsheetFileTypeEnum